import React from 'react';

function Loading() {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
      <div className="mt-4 text-gray-600">Loading...</div>
    </div>
  );
}

export default Loading;